import React from 'react';
import GradientText from './reactbits/GradientText/GradientText';
import ShinyText from './reactbits/ShinyText/ShinyText';
import Reveal from './ui/Reveal';

const AboutBreadcrumbs = () => {
  return (
    <section className="breadcrumbs">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="breadcrumb-wrapper">
              <Reveal className="breadcrumb-cnt" delay={0.06}>
                <span>
                  <GradientText as="span" className="nalexus-heading-gradient" animationSpeed={12}>
                    Nalexus Technologies
                  </GradientText>
                </span>
                <h1>
                  <ShinyText
                    text="About Us"
                    className="nalexus-heading-shine"
                    color="#f1ede3"
                    shineColor="#ffd369"
                    speed={2.6}
                  />
                </h1>
                <p className="breadcrumb-intro">
                  We design and build software that helps teams move faster, reduce manual work, and scale with confidence.
                </p>
                <div className="breadcrumb-list">
                  <a href="/">Home</a>
                  <img src="assets/img/content/breadcrumb-arrow.svg" alt="" />
                  About
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBreadcrumbs;





